import { useMutation } from '@connectrpc/connect-query'
import { exportBilateralTrades } from '@ebalance/proto/bffuser/v1/supply_bilateral_trade_service-SupplyBilateralTradeService_connectquery'

import type { InvalidatingMutationResultFor } from '~/hooks/useInvalidatingMutation'

/**
 * 相対取引契約 CSV エクスポート用の全件取得フック
 * (uploads/common.md §6 AC-DUC-028/029)。
 *
 * `useMutation` を使う (= ダウンロード
 * モーダルを開いた時の 1 回限りの命令的取得であり、 cache には載せない)。
 */
export function useExportBilateralTrades(): InvalidatingMutationResultFor<
  typeof exportBilateralTrades
> {
  return useMutation(exportBilateralTrades)
}
